import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";
import CertificatesTab from "../../components/admin/tabs/CertificatesTab";
import AdminLayout from "../../components/admin/AdminLayout";
import useCertificatesData from "../../hooks/useCertificatesData";
import useAdminActions from "../../hooks/useAdminActions";

const AdminCertificatesPage = () => {
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  const handleCoursesChange = () => {
    // Refresh data if needed
  };

  // Use custom hooks
  const certificatesData = useCertificatesData(user);
  const adminActions = useAdminActions(user, handleCoursesChange, () => {
    // Refresh certificates data
    certificatesData.fetchCertificates();
  });

  const formatDate = (dateString) => {
    if (!dateString) return "Nunca";
    return new Date(dateString).toLocaleString("pt-BR");
  };

  return (
    <AdminLayout user={user} onLogout={handleLogout} title="Certificados Emitidos">
      <CertificatesTab
        certificates={certificatesData.certificates}
        loading={certificatesData.loading}
        error={certificatesData.error}
        certificatesPagination={certificatesData.certificatesPagination}
        certificateSearchTerm={certificatesData.certificateSearchTerm}
        setCertificateSearchTerm={certificatesData.setCertificateSearchTerm}
        onFetchCertificates={certificatesData.fetchCertificates}
        formatDate={formatDate}
      />
    </AdminLayout>
  );
};

export default AdminCertificatesPage;
